import { render, staticRenderFns } from "./DashboardCampaignProgress.vue?vue&type=template&id=8a184b7a&scoped=true&"
import script from "./DashboardCampaignProgress.vue?vue&type=script&lang=js&"
export * from "./DashboardCampaignProgress.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCampaignProgress.vue?vue&type=style&index=0&id=8a184b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a184b7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VProgressLinear})
